import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page5 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content" id="yui_3_17_2_1_1594649889111_38">
                    <div role="main" id="yui_3_17_2_1_1594649889111_37"><span id="maincontent"/>
                        <section id="yui_3_17_2_1_1594649889111_36">
                            <div className="" id="yui_3_17_2_1_1594649889111_35">
                                <div className="ilead-rgt people" id="yui_3_17_2_1_1594649889111_34">
                                    <div className="innerpadding" id="yui_3_17_2_1_1594649889111_33">
                                        <div className="ilead-contentarea" id="yui_3_17_2_1_1594649889111_32">
                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>SELF ASSESSMENT</div>
                                            <p>Completing these statements will identify your listening habits,
                                                and indicate where you might improve.</p>
                                            <ReactToPrint
                                                trigger={() => <div className={'d-flex justify-content-end'}>
                                                    <div onClick={this.downloadPdf} className="button-print">Print</div>
                                                </div>}
                                                content={ () => {
                                                    let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                    let div1 = document.createElement('div');
                                                    div1.className = 'ilead-tools-pages';
                                                    div1.appendChild(html);

                                                    let div2 = document.createElement('div');
                                                    div2.className = 'ilead-tools-body react-print';
                                                    div2.appendChild(div1);

                                                    return div2.cloneNode(true);
                                                }}
                                            />
                                            <br/>
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport people_active"
                                                       id="yui_3_17_2_1_1594649889111_31">
                                                    <tbody id="yui_3_17_2_1_1594649889111_30">
                                                    <tr>
                                                        <th width="50%" align="left" valign="top"
                                                            className="green_curve green_curve1">Active
                                                            Listening Self Assessment Tool
                                                        </th>
                                                    </tr>


                                                    <tr>
                                                        <td width="50%" align="left" valign="top"
                                                            className="lightgreen"><p><span
                                                            className="brown boldtext">1.</span> When I have
                                                            difficulty hearing I...</p>
                                                            <textarea name="WhenIHaveDifficultyHearing"
                                                                      id="WhenIHaveDifficultyHearing"
                                                                      value={pageData?.WhenIHaveDifficultyHearing}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            <br/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="50%" align="left" valign="top"
                                                            className="darkgreen"><p><span
                                                            className="brown boldtext">2.</span> When I have
                                                            difficulty understanding what a speaker means I...
                                                        </p>
                                                            <textarea name="WhenIHaveDifficultyUnderstanding"
                                                                      id="WhenIHaveDifficultyUnderstanding"
                                                                      value={pageData?.WhenIHaveDifficultyUnderstanding}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            <br/>
                                                        </td>
                                                    </tr>


                                                    <tr id="yui_3_17_2_1_1594649889111_29">
                                                        <td width="50%" align="left" valign="top"
                                                            className="lightgreen"
                                                            id="yui_3_17_2_1_1594649889111_28"><p><span
                                                            className="brown boldtext">3.</span> When I agree
                                                            with a speaker's message, I usually...</p>
                                                            <textarea name="WhenIAgreeWithASpeakersMessage"
                                                                      id="WhenIAgreeWithASpeakersMessage"
                                                                      value={pageData?.WhenIAgreeWithASpeakersMessage}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            <br/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="50%" align="left" valign="top"
                                                            className="darkgreen"><p><span
                                                            className="brown boldtext">4.</span> When I disagree
                                                            with a speaker's message, I usually...</p>
                                                            <textarea name="WhenIDisagreeWithASpeakersMessage"
                                                                      id="WhenIDisagreeWithASpeakersMessage"
                                                                      value={pageData?.WhenIDisagreeWithASpeakersMessage}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            <br/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="50%" align="left" valign="top"
                                                            className="lightgreen"><p><span
                                                            className="brown boldtext">5.</span> My
                                                            responsibility as a listener in any situation is...
                                                        </p>
                                                            <textarea name="MyResponsibilityAsAListenerInAnySituation"
                                                                      id="MyResponsibilityAsAListenerInAnySituation"
                                                                      value={pageData?.MyResponsibilityAsAListenerInAnySituation}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            <br/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="50%" align="left" valign="top"
                                                            className="darkgreen"><p><span
                                                            className="brown boldtext">6.</span> As I listen to
                                                            someone speak I do the following to help myself
                                                            understand the message...</p>
                                                            <textarea name="AsIListenToSomeoneSpeak"
                                                                      id="AsIListenToSomeoneSpeak"
                                                                      value={pageData?.AsIListenToSomeoneSpeak}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            <br/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="50%" align="left" valign="top"
                                                            className="lightgreen"><p><span
                                                            className="brown boldtext">7.</span> The most
                                                            important thing that I know about listening is...
                                                        </p>
                                                            <textarea name="TheMostImportantThing"
                                                                      id="TheMostImportantThing"
                                                                      value={pageData?.TheMostImportantThing}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            <br/>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                                <div className="react-print-none">
                                                    <div className="circle_title"><img
                                                        src={require('@images/browndot.jpg')}
                                                        alt=""/>NEXT STEPS</div>
                                                    <p>By now you should have a greater sense of what active
                                                        listening involves and how you can start to consider your
                                                        approach. Below are some suggestions for practical next
                                                        steps following on from this tool:</p>
                                                    <div className="border_subtitle">Review the self assessment
                                                        tool
                                                    </div>
                                                    <p>Review what you have written above to identify your strengths
                                                        and weaknesses. Your strengths will be the kinds of thing
                                                        you do automatically, but your weaknesses may be what you
                                                        rarely or never do, and could now practise.</p>
                                                </div>
                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page4')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div onClick={this.props.savePageData('Page6')}
                                                         className="button-next-previous-done">Next &gt;&gt;</div>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}